import { useEffect } from 'react';
import { LoadingId } from '../../types';
import { useLoadingBarState } from './LoadingBarContext';

/** Suspense fallback for a slot with nothing to show yet: the header's loading bar runs until it resolves. */
export function LoadingBarWhileMounted({ id }: { id: LoadingId }) {
  const { startLoading, stopLoading } = useLoadingBarState().actions;

  useEffect(() => {
    startLoading(id);
    return () => stopLoading(id);
  }, [id, startLoading, stopLoading]);

  return null;
}
